const defaultValues = {
  activePane: "1",
  setActivePane: (newValue) => {},
};
Object.freeze(defaultValues);

export default defaultValues;
